/* Install as a deferred theme asset. This runs in the storefront DOM, outside the pixel sandbox. */
(function () {
  'use strict';
  try {
    if (!window.document || !window.IntersectionObserver || window.__kivviqProductTiles) return;
    window.__kivviqProductTiles = true;
    var doc = window.document;
    var selector = 'a[data-kivviq-product-tile]';
    var observed = new WeakSet();
    var linksByTarget = new WeakMap();
    var impressions = new Set();
    function viewTarget(tile) {
      return tile.closest('[data-kivviq-product-tile-container]') || tile;
    }
    function payload(tile) {
      var data = tile.dataset || {};
      if (!/^[1-9][0-9]{0,29}$/.test(data.productId || '')) return null;
      var out = { productId: data.productId };
      if (data.variantId) {
        if (!/^[1-9][0-9]{0,29}$/.test(data.variantId)) return null;
        out.variantId = data.variantId;
      }
      if (/^[a-zA-Z0-9_:\/-]{1,120}$/.test(data.listId || '')) out.listId = data.listId;
      var position = Number(data.position);
      if (Number.isInteger(position) && position > 0 && position <= 10000) out.position = position;
      return out;
    }
    function publish(name, data) {
      try {
        var analytics = window.Shopify && window.Shopify.analytics;
        if (!analytics || typeof analytics.publish !== 'function') return false;
        var result = analytics.publish(name, data);
        if (result && typeof result.catch === 'function') result.catch(function () {});
        return result !== false;
      } catch (_) { return false; }
    }
    var observer = new window.IntersectionObserver(function (entries) {
      try {
        if (doc.hidden) return;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
          var data = payload(linksByTarget.get(entry.target) || entry.target);
          if (!data) return;
          var key = JSON.stringify(data);
          if (impressions.has(key)) return;
          if (publish('kivviq:product_tile_viewed', data)) impressions.add(key);
        });
      } catch (_) { /* Analytics must not affect storefront behavior. */ }
    }, { threshold: [0, 0.5] });
    function refresh() {
      try {
        doc.querySelectorAll(selector).forEach(function (tile) {
          var target = viewTarget(tile);
          linksByTarget.set(target, tile);
          if (!observed.has(target)) { observed.add(target); observer.observe(target); }
        });
      } catch (_) {}
    }
    doc.addEventListener('click', function (event) {
      try {
        var tile = event.target && event.target.closest && event.target.closest(selector);
        if (!tile) return;
        var data = payload(tile);
        if (data) publish('kivviq:product_tile_selected', data);
      } catch (_) {}
    });
    doc.addEventListener('visibilitychange', function () {
      if (doc.hidden) return;
      try { doc.querySelectorAll(selector).forEach(function (tile) { var target = viewTarget(tile); observer.unobserve(target); observer.observe(target); }); } catch (_) {}
    });
    refresh();
    if (window.MutationObserver) new window.MutationObserver(refresh).observe(doc.documentElement, { childList: true, subtree: true });
  } catch (_) { /* Unsupported browsers keep a working storefront. */ }
})();
